import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { CoreService } from '@portal-client/core/core.service';
import { Observable } from 'rxjs';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent, MatDialogClose } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'mc-app-about-dialog',
    templateUrl: './app-about-dialog.component.html',
    styleUrls: ['./app-about-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [CdkScrollable, MatDialogContent, MatIconButton, MatDialogClose, MatIcon, AsyncPipe]
})
export class AppAboutDialogComponent implements OnInit {
  private readonly coreService = inject(CoreService);

  currentYear = new Date().getFullYear();
  appVersionAndBuildDate$: Observable<string>;

  ngOnInit() {
    this.appVersionAndBuildDate$ = this.coreService.getVersionAndBuildDate$();
  }
}
